import { render, staticRenderFns } from "./AcademyLayout.vue?vue&type=template&id=492dd426&scoped=true"
import script from "./AcademyLayout.vue?vue&type=script&lang=js"
export * from "./AcademyLayout.vue?vue&type=script&lang=js"
import style0 from "./AcademyLayout.vue?vue&type=style&index=0&id=492dd426&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492dd426",
  null
  
)

export default component.exports